
import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Spin, Form, Select, Input, DatePicker, Tooltip, Radio, Checkbox, Button, Tag } from 'antd';
import { useParams } from 'react-router-dom';
import Header from "../../components/Header"
import Footer from '../../components/Footer';
import api from '../../services/api';
import './styles.css';
import { message } from 'antd';
import { AxiosResponse } from 'axios';
import MaskedInput from 'react-input-mask'
import { paises } from '../../assets/paises'
import { ColumnsType } from 'antd/lib/table';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as PermissaoAction from '../../redux/actions/permissao';

import 'antd/dist/antd.css';
import moment from 'moment';

interface HistoricoProps {
    permissao?: any
}

const Historico: React.FC<HistoricoProps> = (prop) => {
    let agendamento: any;
    let agendamentos: any[] = [];
    const [historicoResponse, setHistoricoResponse] = useState<any[]>();
    const [loading, setLoading] = useState(false);
    const [situacoesInput, setSituacoesInput] = useState<any[]>();
    const { Option } = Select;
    var situacoes: any[] = [];
    const [form] = Form.useForm();

    useEffect(() => {
        api.get(`Agendamento/getsituacoesagendamento`).then((response) => {
            situacoes = response.data;
            setSituacoesInput(situacoes)
        })
        getHistoricoAgendamentos();
    }, [])

    const getHistoricoAgendamentos = async () => {
        api.get(`Agendamento/gethistoricoagendamento`).then((response) => {
            response.data.forEach((e: any) => {
                let dataHoraIncio: any = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(e.dataHoraInicio))
                let dataHoraFinal: any = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(e.dataHoraFinal))
                agendamento = {
                    key: e.agendamentoID,
                    dataHoraInicio: dataHoraIncio,
                    dataHoraFinal: dataHoraFinal,
                    agendamentoID: e.agendamentoID,
                    dadosCadastraisID: e.dadosCadastraisID,
                    duracao: e.duracao,
                    motivo: e.motivo,
                    nome: e.nome,
                    paisOrigem: e.paisOrigem,
                    situacao: e.situacao,
                    servicosOfertados: e.servicosOfertados
                }
                agendamentos.push(agendamento);
            });
            setHistoricoResponse(agendamentos);
        })
    }

    function toISOFormat(dateTimeString: string) {
        // Primeiro, dividimos a data completa em duas partes:
        const [DD, MM, YYYY] = dateTimeString.split('/');
        // Retornamos a data formatada em um padrão compatível com ISO:
        return `${YYYY}-${MM}-${DD}`;
    }

    const validarData = (_: any, value: { number: number }) => {
        if (form.getFieldValue("dataAgendamento") != undefined) {
            let result, data;
            let dataFormatada = toISOFormat(form.getFieldValue("dataAgendamento"));
            data = new Date(dataFormatada);
            result = moment(data).isValid();
            if (result == false) {
                return Promise.reject(new Error('Data inválida!'));
            }
            return Promise.resolve();
        }
        return Promise.resolve();
    };


    const Buscar = async (values: any) => {
        let data;

        if (values.dataAgendamento != undefined) {
            let dataFormatada = toISOFormat(values.dataAgendamento);
            data = new Date(dataFormatada);
        }
        await api.post(`Agendamento/gethistoricoagendamentofiltro`, {
            AgendamentoID: 0,
            Nome: values.nome,
            DataHoraInicio: data,
            PaisOrigem: values.pais,
            Situacao: values.situacao,
        })
            .then((response: any) => {
                if (response.status == 200) {
                    response.data.forEach((e: any) => {
                        let dataHoraIncio: any = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(e.dataHoraInicio))
                        let dataHoraFinal: any = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(e.dataHoraFinal))
                        agendamento = {
                            key: e.agendamentoID,
                            dataHoraInicio: dataHoraIncio,
                            dataHoraFinal: dataHoraFinal,
                            agendamentoID: e.agendamentoID,
                            dadosCadastraisID: e.dadosCadastraisID,
                            duracao: e.duracao,
                            motivo: e.motivo,
                            nome: e.nome,
                            paisOrigem: e.paisOrigem,
                            situacao: e.situacao,
                            servicosOfertados: e.servicosOfertados
                        }
                        agendamentos.push(agendamento);
                    });
                    setHistoricoResponse(agendamentos);
                    setLoading(false);
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')
                setLoading(false);
            });

        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 50);
    };

    const columns: ColumnsType<any> = [
        {
            title: 'Nome - País',
            dataIndex: 'nome',
            key: 'nome',
        },
        {
            title: 'Data/Hora',
            dataIndex: 'dataHoraInicio',
            key: 'dataHoraInicio',
        },
        // {
        //     title: 'Data/Hora Final',
        //     dataIndex: 'dataHoraFinal',
        //     key: 'dataHoraFinal',
        // },
        {
            title: 'Motivo',
            dataIndex: 'motivo',
            key: 'motivo',
            ellipsis: {
                showTitle: false,
            },
            render: motivo => (
                <Tooltip placement="topLeft" title={motivo}>
                    {motivo}
                </Tooltip>
            ),
        },
        {
            title: 'Situação',
            dataIndex: 'situacao',
            key: 'situacao',
        },
        {
            title: 'Serviços Ofertados',
            dataIndex: 'servicosOfertados',

            render: (servicosOfertados: any) => (
                servicosOfertados ? servicosOfertados.map((option: any, index: any) => {
                    return <Tooltip key={index} title={option.vinculoOrgaoServicoID == 0 ? null : option.vinculoOrgaoServico.servico ? 'Serviço: ' + option.vinculoOrgaoServico.servico.descricao : null}>
                        <Tag key={index}  >
                            {option.vinculoOrgaoServicoID == 0 ? option.orgaoID !== 0 ? option.nomeOrgao : option.outro : option.vinculoOrgaoServico.orgao ? option.vinculoOrgaoServico.orgao.nome.length < 20 ? option.vinculoOrgaoServico.orgao.nome : option.vinculoOrgaoServico.orgao.sigla : null}
                        </Tag>
                    </Tooltip>
                }) : null
            )
        },
    ];

    return (
        <div>
            <Header></Header>
            <br />
            <div className="container">
                <fieldset className="fieldset-consulta">
                    <Spin spinning={loading}>
                        <Form onFinish={Buscar}
                            labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                            layout="horizontal"
                            size="middle"
                            form={form}
                        >
                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="Nome"
                                        name="nome"
                                    >
                                        <Input placeholder="Informe o nome do Migrante" />
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="País de Origem"
                                        name="pais"
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            placeholder="selecione um país"
                                        >
                                            <Select.Option value="">Selecione</Select.Option>

                                            {paises.map((p, index) => <Select.Option key={index} value={p}>{p}</Select.Option>)}

                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="Data"
                                        name="dataAgendamento"
                                        rules={[
                                            {
                                                validator: validarData
                                            }
                                        ]}
                                    >
                                        <MaskedInput className="ant-input" placeholder="Informe a Data" mask="99/99/9999" />
                                        {/* <DatePicker placeholder="Selecione a Data" style={{ width: '100%' }} format="DD/MM/YYYY" /> */}
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="Situação"
                                        name="situacao"
                                        initialValue="Aberto"
                                    >
                                        <Select placeholder="Situação">
                                            {situacoesInput?.map(situacao => (
                                                <Option value={situacao.enum}>{situacao.enum}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item>
                                <Button className="button-filtrar" type="primary" htmlType="submit">
                                    Filtrar
                                </Button>
                            </Form.Item>
                        </Form>
                    </Spin>
                </fieldset>
                <br />
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Table loading={loading} columns={columns} dataSource={historicoResponse} key={"agendamentoID"} bordered={true}></Table>
                    </Col>
                </Row>
            </div>
            <Footer></Footer>
        </div>

    );
}

const mapStateToProps = (state: any) => ({
    permissao: state.permissao,
})

const mapDispatcToProps = (dispatch: any) => bindActionCreators(PermissaoAction, dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(Historico);
